import { render, staticRenderFns } from "./changePsd.vue?vue&type=template&id=0c8fc26a&scoped=true"
import script from "./changePsd.vue?vue&type=script&lang=js"
export * from "./changePsd.vue?vue&type=script&lang=js"
import style0 from "./changePsd.vue?vue&type=style&index=0&id=0c8fc26a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8fc26a",
  null
  
)

export default component.exports